// extracted by mini-css-extract-plugin
export default {"image":"T0-z","loaded":"U0-z"};